/**
 * Android 디바이스 모드 감지 훅 (태블릿 전용)
 *
 * 사용법:
 *   const { mode, isPortrait } = useDeviceMode()
 *   const header = HeaderSize[mode]
 */

import { useMemo } from "react"
import useMediaQuery from "@mui/material/useMediaQuery"
import { MediaQuery } from "../styles/AndroidResponsive"
import type { DeviceMode } from "../styles/AndroidResponsive"

// ═══════════════════════════════════════════════════════
// useDeviceMode — 현재 디바이스 모드 반환
// ═══════════════════════════════════════════════════════

export interface DeviceModeResult {
  /** 현재 디바이스 모드 */
  mode: DeviceMode
  /** 세로 방향 여부 */
  isPortrait: boolean
  /** 폰 여부 (태블릿 전용이므로 항상 false) */
  isPhone: boolean
}

export function useDeviceMode(): DeviceModeResult {
  const isPortrait = useMediaQuery(MediaQuery.portrait)

  const mode: DeviceMode = useMemo(() => {
    return isPortrait ? "tabletPortrait" : "tabletLandscape"
  }, [isPortrait])

  return {
    mode,
    isPortrait,
    isPhone: false,
  }
}
